import "../styles/detail.scss";
import { items, logos } from "../services/data.ts";

const Detail = ({ index }) => {
    const { title, description, subs } = items.details[index];

    return (
        <div className="detail" id="detail">
            <div className="line" />
            <div
                id="return"
                onClick={() => {
                    document.getElementById(`service-${index}`)?.scrollIntoView({ behavior: "smooth" });
                }}
            >
                <img src={logos.arrow_up} id="up" />
                <p>Voltar</p>
            </div>
            <div className="detail-box">
                <div className="detail-intro">
                    <h3 className="detail-title">{title}</h3>
                    <p className="detail-description">{description}</p>
                </div>
                <div className="detail-grid">

                    {subs.map((sub, subIndex) => (
                        <div className="detail-item" key={subIndex}>
                            <h4 className="detail-item-title">{sub.title}</h4>
                            <p className="detail-item-desc justify">{sub.description}</p>
                            {Array.isArray(sub.topics) && sub.topics.length > 0 && (
                                <ul className="detail-item-topics justify">
                                    {sub.topics.map((topic, topicIndex) => (
                                        <li key={topicIndex}><span className="hifen">-</span>
                                        <>
                                        <span className="position1">{topic[0]}</span>
                                        {topic[1]}
                                        </>
                                        
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}
                </div>

            </div>
            <div className="line" />
        </div>
    );
};

export default Detail;
